import SharedPreferences from "../../constants/SharedPreferences";
import {
  getErrorMessage,
  saveInStorage,
  logApiResponse,
  saveEccCurvesFromResponse,
} from "../../util/Utility";
import {
  getNonAuthRestClient,
  getNonAuthRestClientForAdmin,
} from "../RestUtility";
import BayunError from "../../constants/BayunError";
import {
  getMessageFromSignatureString,
  retrieveAndverifyLastSignature,
} from "../../util/SignatureUtil";
export const registerUserApi = async (
  sessionId,
  appId,
  appKeyPairId,
  appSecret,
  orgMemberId,
  orgName,
  email,
  isOrgOwnedEmail,
) => {
  await saveInStorage(sessionId, SharedPreferences.EMAIL_ADDRESS, email);

  const restClient = await getNonAuthRestClient(appId, appKeyPairId);

  const registerUserResponse = await restClient.post("/registerUser", {
    orgMemberId,
    orgName,
    email,
    isOrgOwnedEmail,
  });

  await logApiResponse("registerUserResponse", registerUserResponse);

  await saveInStorage(
    sessionId,
    SharedPreferences.ENCRYPTION_TYPE,
    registerUserResponse.data.encryptionType,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.USER_ID,
    getMessageFromSignatureString(registerUserResponse.data.userId),
  );
};

export const registerDeveloperAccount = async (
  sessionId,
  email,
  isOrgOwnedEmail,
  failureCallback,
) => {
  await saveInStorage(sessionId, SharedPreferences.EMAIL_ADDRESS, email);

  const restClient = getNonAuthRestClientForAdmin(sessionId);

  let registerDeveloperAccountResp;
  try {
    registerDeveloperAccountResp = await restClient.post(
      "/admin/registerUser",
      {
        email,
        isOrgOwnedEmail,
      },
    );
  } catch (error) {
    console.log(error);
    console.log(error?.response?.data ?? error);
    failureCallback(getErrorMessage(sessionId, error?.response?.data?.errorMessage ?? error));
    return;
  }
  await logApiResponse(
    "registerDeveloperAccountResp",
    registerDeveloperAccountResp,
  );

  if (registerDeveloperAccountResp.data.userPublicKey) {
    await saveInStorage(
      sessionId,
      SharedPreferences.USER_PUBLIC_KEY,
      getMessageFromSignatureString(
        registerDeveloperAccountResp.data.userPublicKey,
      ),
    );
  }

  await saveInStorage(
    sessionId,
    SharedPreferences.ENCRYPTION_TYPE,
    registerDeveloperAccountResp.data.encryptionType,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.BAYUN_SERVER_PUBLIC_KEY,
    registerDeveloperAccountResp.data.bayunServerPublicKey,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.USER_ID,
    getMessageFromSignatureString(registerDeveloperAccountResp.data.userId),
  );

  await saveEccCurvesFromResponse(sessionId, registerDeveloperAccountResp.data);
  await saveInStorage(
    sessionId,
    SharedPreferences.ENCRYPTION_TYPE,
    registerDeveloperAccountResp.data.encryptionType,
  );
  await saveInStorage(
    sessionId,
    SharedPreferences.MULTI_FACTOR_AUTH,
    registerDeveloperAccountResp.data.multiFactorAuthentication,
  );
  await saveInStorage(
    sessionId,
    SharedPreferences.IS_NEW_USER,
    registerDeveloperAccountResp.data.newUser,
  );

  return registerDeveloperAccountResp;
};

export const loginDeveloperAccount = async (
  sessionId,
  email,
  failureCallback,
) => {
  await saveInStorage(sessionId, SharedPreferences.EMAIL_ADDRESS, email);

  const restClient = getNonAuthRestClientForAdmin(sessionId);
  let authenticationWithEmailResp;
  try {
    authenticationWithEmailResp = await restClient.get(
      "/admin/authenticateWithEmail",
      {
        params: {
          email: email,
        },
      },
    );
  } catch (error) {
    console.log(error);
    console.log(error?.response?.data ?? error);
    failureCallback(getErrorMessage(sessionId, error?.response?.data ?? error));
    return;
  }

  await logApiResponse(
    "authenticationWithEmailResp",
    authenticationWithEmailResp,
  );

  const resp = authenticationWithEmailResp.data;

  // The user-scoped signing contexts are built as "userPublicKey$<email>", and
  // /admin/twofa/twoFAData omits the email while the account is in recovery, so the email is
  // persisted here from the login input the server has just resolved this user by.
  await saveInStorage(sessionId, SharedPreferences.EMAIL_ADDRESS, email);

  if (resp.lastLoggedInAccountType) {
    await saveInStorage(
      sessionId,
      SharedPreferences.LAST_LOGGED_IN_ACCOUNT_TYPE,
      resp.lastLoggedInAccountType,
    );
  }

  await saveInStorage(
    sessionId,
    SharedPreferences.MULTI_FACTOR_AUTH,
    resp.multiFactorAuthentication,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.USER_STATUS,
    resp.userStatus,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.IS_DEVELOPER,
    resp.isDeveloper,
  );

  await saveInStorage(
    sessionId,
    SharedPreferences.BAYUN_SERVER_PUBLIC_KEY,
    resp.bayunServerPublicKey,
  );

  await saveEccCurvesFromResponse(sessionId, resp);

  await saveInStorage(
    sessionId,
    SharedPreferences.ENCRYPTION_TYPE,
    resp.encryptionType,
  );

  const userId = getMessageFromSignatureString(resp.userId);
  await saveInStorage(sessionId, SharedPreferences.USER_ID, userId);

  if (resp.memberAccountResponse) {
    //Verify and save memberId
    if (
      !(await retrieveAndverifyLastSignature(
        sessionId,
        resp.memberAccountResponse.memberId,
      ))
    ) {
      console.log("memberId verification failed.");
      failureCallback(BayunError.ERROR_MEMBER_VERIFICATION_FAILED);
      return;
    } else {
      await saveInStorage(
        sessionId,
        SharedPreferences.MEMBER_ID,
        getMessageFromSignatureString(resp.memberAccountResponse.memberId),
      );
    }

    await saveInStorage(
      sessionId,
      SharedPreferences.ORG_MEMBER_ID,
      resp.memberAccountResponse.orgMemberId,
    );

    await saveInStorage(
      sessionId,
      SharedPreferences.ORG_NAME,
      resp.memberAccountResponse.orgName,
    );
  }

  return resp;
};
